import RentalPeriodForm from './rental-period-form';

export default RentalPeriodForm;
